import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=6b3111fe&scoped=true"
import script from "./CustomersList.vue?vue&type=script&lang=js"
export * from "./CustomersList.vue?vue&type=script&lang=js"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=6b3111fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3111fe",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBanner,QBtn,QChip,QSpace,QTooltip,QSeparator,QInput,QPopupProxy,QSelect,QTable,QTr,QIcon,QBadge,QRating,QTd,QCardActions,QBtnGroup,QDialog});qInstall(component, 'directives', {ClosePopup});
